export default __webpack_public_path__ + "static/media/ShoeRepair.c5e0efe4.png";